import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { Http } from '@angular/http';
import { ModalController } from 'ionic-angular';
import config from '../../config/config';
import {FormunicoPage} from '../formunico/formunico';


/**
 * Generated class for the AguardandoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
 
@IonicPage()
@Component({
  selector: 'page-aguardando',
  templateUrl: 'aguardando.html',
})
export class AguardandoPage {
loading = null;
aguardes=null;
  constructor(
  	public navCtrl: NavController,
     public navParams: NavParams,
     public loadingCtrl: LoadingController,
    public _http: Http,
    public modalCtrl : ModalController
    ) {
  }

  ionViewDidLoad() {
    this.gettax(2);

  }
    carregando(){
      this.loading = this.loadingCtrl.create({
    content: 'Aguarde.'
  });
  this.loading.present();
  }
   gettax(status){
   	this.carregando(); 
     this._http
        .get(config.urlAPI+"formulario/tax/"+status,{})
        .map(res => res.json())
        .toPromise()
        .then(res => { 
        	this.loading.dismiss();
        	this.aguardes = res;
        }).catch(error => {
          console.log(error);

        });

}
abrirform(item){

	    let formunico = this.modalCtrl.create(FormunicoPage,{item});
       formunico.onDidDismiss(data => {
     this.gettax(2);
   });
   formunico.present();
}
}


// WEBPACK FOOTER //
// ./src/pages/aguardando/aguardando.ts